import { StatisticsAreaGranularityEnum } from '@model/enum/statistics-granularity.enum';
import { useCpmsBoGetTransactionReportsCountByChargePointQuery } from '@service/cpms-bo-transaction-reports-count-statistics.service';

import {
  MoreLessCard,
  MoreLessCardVariantEnum,
} from '../../components/more-less-card/more-less.card';
import { useFilters } from '../../context/filters.context';

export const MoreLessTransactionsChargePointCardComponent =
  (): React.JSX.Element | null => {
    const {
      transformedFilters,
      filters: { areaGranularity },
    } = useFilters();

    const { data } = useCpmsBoGetTransactionReportsCountByChargePointQuery({
      ...transformedFilters,
    });

    return areaGranularity !== StatisticsAreaGranularityEnum.ChargePoint ? (
      <MoreLessCard
        data={data}
        variant={MoreLessCardVariantEnum.Transactions}
      />
    ) : null;
  };
